'use es6';

export const productPurchaseMotionsAdapter = (purchaseMotionData, location, apiName) => {
  const purchaseMotionDataByLocation = purchaseMotionData && purchaseMotionData.locations && purchaseMotionData.locations[location];
  const purchaseMotions = purchaseMotionDataByLocation && purchaseMotionDataByLocation.purchaseMotions && purchaseMotionDataByLocation.purchaseMotions[apiName];
  const parsedPurchaseMotions = purchaseMotions ? purchaseMotions.map((obj = {}) => obj.key) : [];
  return parsedPurchaseMotions;
};